import React from 'react';
import AttendanceHistoryDashboard from '../../components/AttendanceHistoryDashboard';

export const Dashboard = () => {
  return <AttendanceHistoryDashboard />;
};
